<div class="mb-3 message-card red">
    <mwp-text-translate text="Listed below are the requests that will be cancelled based on your new elections. Clicking confirm will remove the requests from the system." jsonKey="CancelRequestNote" />
</div>
<div class="content-container table-comp mb-3">
    <div class="title">
        <mwp-text-translate text="Cancel Benefits" jsonKey="cancelBenefits" /> 
    </div>
    <div class="content">
        <mwp-table-formarray [form]="termForm" [arrayName]="termFormArrayName" [tableColumns]="cancelBenefitColumns" [dataSource]="cancelBenefitData" />
    </div>
    <div class="footer">
        <mwp-benefit-enrollment-wizard-control [isContinueDisabled]="termForm.invalid" (emitComplete)="submitTermComplete()"></mwp-benefit-enrollment-wizard-control>
    </div>
</div>
